import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { img2 } from "../_components/Imagepath";


import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
// import * as Yup from "yup";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";

const AddCustomer = () => {
  const [countriesList, setCountriesList] = useState([]);
  const [AddressTypeList, setAddressTypeList] = useState([]);
  const [incotermsList, setIncotermsList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [phytoTypes, setPhytoTypes] = useState([]);
  const [menu, setMenu] = useState(false);
  const [showTableHeadings, setShowTableHeadings] = useState(false);
  const [showTableHeadingsContact, setShowTableHeadingsContact] = useState(false);
  const [showTableHeadingsBroker, setShowTableHeadingsBroker] = useState(false);
  const [showTableHeadingsUser, setShowTableHeadingsUser] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [farmerLists, setFarmerLists] = useState([]);
  // const [farmvalue, setFarmvalue] = useState({});
  const [permission, setPermission] = useState({});

  const [locationLoading, setLocationLoading] = useState([]);
  const handleAddRow = (arrayHelpers) => {
    arrayHelpers.push({
      address_type: "",
      name: "",
      email: "",
      phone_number: "",
      street: "",
      city: "",
      zip_code: "",
      country: "",
    });
    setShowTableHeadings(true); // Show table headings after adding a row
  };
  const handleAddRowContact = (arrayHelpersContact) => {
    arrayHelpersContact.push({
      contact_first_name: "",
      contact_last_name: "",
      contact_email: "",
      contact_phone_number:"",
      contact_function: "",
    });
    setShowTableHeadingsContact(true); // Show table headings after adding a row
  };

  const handleAddRowuser = (arrayHelpersUser) => {
    arrayHelpersUser.push({
      user_first_name: "",
      user_last_name: "",
      user_email: "",
      user_password:"",
      user_function: "",
      user_type: "",
    });
    setShowTableHeadingsUser(true); // Show table headings after adding a row
  };

  const handleAddRowBroker = (arrayHelpersContact) => {
    arrayHelpersContact.push({
      broker_name: "",
      broker_phone_number: "",
      broker_email: "",
      broker_co_code:"",
      broker_phyto_type: "",
      broker_address: "",
    });
    setShowTableHeadingsBroker(true); // Show table headings after adding a row
  };
 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];
  const formik = useFormik({
    initialValues: {
      company_email: "",
      company_name: "",
      company_phone: "",
      company_logo: "",
      company_website: "",
      company_primary_currency: "",
      incoterm: "",
      payment_term: "",
      vat:"",
      address: [],
      contacts: [],
      brokers: [],
      documents: [],
      customer_farms: [],
      customer_processing:[],
    },
    //validationSchema: AddCustomerSchema,

    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/customers/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          
          delete backendErrors['error'];
          $("#form-submit").text("Add Customer");
   

        //  actions.setSubmitting(false);
        setSubmitting(false);

          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/customers";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }


        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
        setPermission(FindModuleById(2)); 
        console.log(permission);


    axios
    .get(`/helpers/loading-locations`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        // let locations = response.data.data.locations;
        // setLocationLoading(locations);
        let locations = response.data.data.locations;
        let emp_statusList = locations.map((ord, index) => ({
          gps_location: ord.gps_location,
          description: ord.description,
          label:  ord.title ,
          value: ord.id,
          key: `sts-${index}`,
        }));
        

        setLocationLoading(emp_statusList);

      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

    axios
    .post(
      "/farmers/listing",
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let farmers = response.data.data.farmers;
        let productslisting = farmers.map((customer, index) => ({
          ggn_number: customer.ggn_number,
          farm_size: customer.farm_size,
          estimated_crops: customer.estimated_crops,
          label: customer.name,
          value: customer.id,
          key: `farmer-${index}`,
        }));
        setFarmerLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });


    axios
    .get(`/helper/customers-contract-file-types`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let types = response.data.data.types;
        let typeslisting = types.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setFileTypes(typeslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });


    axios
      .get(`/helpers/broker-phyto-types`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let countries = response.data.data.types;
          let countrieslisting = countries.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `country-${index}`,
          }));
          setPhytoTypes(countrieslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
   
    axios
      .get(`/helpers/countries`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let countries = response.data.data.countries;
          let countrieslisting = countries.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `country-${index}`,
          }));
          setCountriesList(countrieslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `/helpers/address-types`,

        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let address_types = response.data.data.address_types;
          let addresstypeslisting = address_types.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `types-${index}`,
          }));
          setAddressTypeList(addresstypeslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `/helpers/incoterms`,

        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let incoterms = response.data.data.incoterms;
          let incotermslisting = incoterms.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `types-${index}`,
          }));
          setIncotermsList(incotermslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(
        `/helpers/payments-terms`,

        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let terms = response.data.data.terms;
          let termslisting = terms.map((terms, index) => ({
            label: terms.name,
            value: terms.id,
            key: `terms-${index}`,
          }));
          setPaymentTermList(termslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  

  const getFarmLocationData = (e, id_value) => {
    var gps_location = e ? e.gps_location : '';
    var description = e ? e.description : '';
    
    
    // const answer_array = id_value.split('-');

    $("#gps_location-"+id_value+"").val(gps_location);
    $("#description-"+id_value+"").val(description);
    formik.values.customer_processing[id_value].gps_location = gps_location;
    formik.values.customer_processing[id_value].description = description;
    const index = id_value;

    // Update the Formik state
    formik.setFieldValue(`customer_processing[${index}].gps_location`, gps_location);
    formik.setFieldValue(`customer_processing[${index}].description`, description);
  }

  // const getFarmData = (e, index) => {
  //   const id = e.value;

  //   axios
  //   .get(`/farmers/edit/${id}`, {
  //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //   }).then((response) => {
  //     if (response.data.code === 200) {
  //      // setFarmvalue(response.data.data.farmer);
  //       let farm_data = response.data.data.farmer;
        
  //       $("#ggn_number-"+index+"").val(farm_data.ggn_number);
   
  //       $("#farm_size-"+index+"").val(farm_data.farm_size);
   
  //       $("#estimated_crops-"+index+"").val(farm_data.estimated_crops);
   
  //     }
  //   })
  //   .catch((error) => {
  //     toast.error(error);
  //   });
  // };
  const getFarmData = (farm_data, index) => {
        formik.setFieldValue(`customer_farms[${index}].ggn_number`, farm_data.ggn_number);
        formik.setFieldValue(`customer_farms[${index}].farm_size`, farm_data.farm_size);
        formik.setFieldValue(`customer_farms[${index}].estimated_crops`, farm_data.estimated_crops);
    console.log(farm_data);
    console.log(index);
  }
    // axios
    //   .get(`/farmers/edit/${id}`, {
    //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    //   })
    //   .then((response) => {
    //     if (response.data.code === 200) {
    //       let farm_data = response.data.data.farmer;
  
    //       // Update Formik values instead of jQuery
    //       // formik.setFieldValue(`customer_farms[${index}].ggn_number`, farm_data.ggn_number);
    //       // formik.setFieldValue(`customer_farms[${index}].farm_size`, farm_data.farm_size);
    //       // formik.setFieldValue(`customer_farms[${index}].estimated_crops`, farm_data.estimated_crops);
    //       // formik.setFieldValue(`customer_farms[${index}].ggn_number`, farm_data.ggn_number);
    //           // Fix: Use the correct field names that match your inputs
    //     formik.setFieldValue(`contents[${index}].ggn_number`, farm_data.ggn_number);
    //     formik.setFieldValue(`contents[${index}].farm_size`, farm_data.farm_size);
    //     formik.setFieldValue(`contents[${index}].estimated_crops`, farm_data.estimated_crops);
    //     }
    //   })
    //   .catch((error) => {
    //     toast.error(error);
    //   });
  // };
  // Updated getFarmData function with API call
// const getFarmData = (selectedOption, index) => {
//   const farmId = selectedOption.value;
  
//   // Make API call to get farm data
//   axios
//     .get(`/farmers/edit/${farmId}`, {
//       headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
//     })
//     .then((response) => {
//       if (response.data.code === 200) {
//         let farm_data = response.data.data.farmer;
        
//         // Set the values in Formik
//         formik.setFieldValue(`customer_farms[${index}].ggn_number`, farm_data.ggn_number || '');
//         formik.setFieldValue(`customer_farms[${index}].farm_size`, farm_data.farm_size || '');
//         formik.setFieldValue(`customer_farms[${index}].estimated_crops`, farm_data.estimated_crops || '');
        
//         console.log('Farm data:', farm_data);
//         console.log('Index:', index);
//         console.log('Updated Formik values:', formik.values);
//       }
//     })
//     .catch((error) => {
//       console.error('Error fetching farm data:', error);
//       toast.error('Error fetching farm data');
//     });
// };
  const getFileData = async (event) =>{
    const file_link = event.target.files[0];
    const fileName = file_link.name;
    const withoutExtension = fileName.replace(/\.[^.]+$/, '');

    var id_value = event.target.id;
    const ids = id_value.split("-");
    formik.values.documents[ids[1]].file_name = withoutExtension;
  }    
  
const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};

const usertypes = ([
  { value: 1, label: "Administrator" },
  { value: 2, label: "Standard" },
]);


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
          <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Customers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customers">Customers</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Customer</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.add == 1 && (

                  <div className="card-body">
                    <h4 className="card-title">Company Info</h4>
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                        <div className="row justify-content-lg-center">
                          <div className="col-lg-10">
                            <div className="text-center py-5">
                              <label
                                className="avatar avatar-xxl profile-cover-avatar"
                                htmlFor="avatar_upload"
                              >
                                <img
                                  className="avatar-img"
                                  src={formik.values.company_logo || img2}
                                  alt="Company Logo"
                                />
                                <input
                                  type="file"
                                  id="avatar_upload"
                                  onChange={(event) => {
                                    const file = event.target.files[0];
                                    const reader = new FileReader();

                                    reader.onloadend = () => {
                                      formik.handleChange({
                                        target: {
                                          name: "company_logo",
                                          value: reader.result,
                                        },
                                      });
                                    };

                                    if (file) {
                                      reader.readAsDataURL(file);
                                    }
                                  }}
                                />

                                <span className="avatar-edit">
                                  <FeatherIcon
                                    icon="edit-2"
                                    className="avatar-uploader-icon shadow-soft"
                                  />
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Company Name</label>
                              <input
                                type="text"
                                name="company_name"
                                value={formik.values.company_name}
                                className={
                                  formik.errors.company_name
                                    ? "form-input form-control input-error"
                                    : "form-input form-control"
                                }
                               // onChange={formik.handleChange}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.company_name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_name}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>Company Email</label>
                              <input
                                type="text"
                                name="company_email"
                                value={formik.values.company_email}
                                className={
                                  formik.errors.company_email
                                    ? "form-input form-control input-error"
                                    : "form-input form-control"
                                }
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.company_email && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_email}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group status">
                              <label>Select Currency</label>
                              {primaryCurrency.length > 0 && (
                                <Select
                                className="w-100"
                                value={primaryCurrency.find(option => option.value == formik.values.company_primary_currency) || null} // Ensure correct format
                                name="company_primary_currency"
                                 onChange={(selectedOption) => handleSelectChange("company_primary_currency", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={primaryCurrency}
                                placeholder="Select"

                                  
                                />
                              )}
                             
                              <small>
                                {backendErrors.company_primary_currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_primary_currency}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group status">
                              <label>Payment Terms</label>
                              {paymentTermList.length > 0 && (
                                <Select
                                className="w-100"
                                value={paymentTermList.find(option => option.value == formik.values.payment_term) || null} // Ensure correct format
                                name="payment_term"
                                 onChange={(selectedOption) => handleSelectChange("payment_term", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={paymentTermList}
                                placeholder="Select"
                                />
                              )}
                              <small>
                                {formik.errors.terms &&
                                  formik.touched.terms && (
                                    <span className="form-error mt-1">
                                      {formik.errors.terms}
                                    </span>
                                  )}
                              </small>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Company Phone</label>
                              <input
                                type="text"
                                name="company_phone"
                                value={formik.values.company_phone}
                                className={
                                  formik.errors.company_phone
                                    ? "form-input form-control input-error"
                                    : "form-input form-control"
                                }
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.company_phone && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_phone}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>Company Website</label>
                              <input
                                type="text"
                                name="company_website"
                                value={formik.values.company_website}
                                className={
                                  formik.errors.company_website
                                    ? "form-input form-control input-error"
                                    : "form-input form-control"
                                }
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.company_website && (
                                    <span className="form-error mt-1">
                                      {backendErrors.company_website}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group status">
                              <label>Incoterm</label>
                              {incotermsList.length > 0 && (
                                <Select
                                className="w-100"
                                value={incotermsList.find(option => option.value == formik.values.incoterm) || null} // Ensure correct format
                                name="incoterm"
                                 onChange={(selectedOption) => handleSelectChange("incoterm", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={incotermsList}
                                placeholder="Select"

                                  
                                />
                              )}
                              <small>
                                {backendErrors.incoterm && (
                                    <span className="form-error mt-1">
                                      {backendErrors.incoterm}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>VAT</label>
                              <input
                                type="text"
                                name="vat"
                                value={formik.values.vat}
                                className="form-input form-control"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.vat && (
                                    <span className="form-error mt-1">
                                      {backendErrors.vat}
                                    </span>
                                  )}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add Address
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="address"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => handleAddRow(arrayHelpers)}
                              >
                                +
                              </button>
                              {showTableHeadings && (
                                <table  className="table mb-0">
                                  <thead>
                                    <tr>
                                      <td>Address Type</td>
                                      <td>Name</td>
                                      <td>Email</td>
                                      <td>Phone Number</td>
                                      <td>Street</td>
                                      <td>City</td>
                                      <td>Zip Code</td>
                                      <td>Country</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.address.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className=" status">
                                              {/* <label>Address Type</label> */}
                                              <Select
                                              name={`address[${index}].address_type`}
                                              options={AddressTypeList}
                                              value={AddressTypeList.find(option => option.value == formik.values.address[index].address_type) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`address[${index}].address_type`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `address[${index}].address_type`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select" 
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              {/* <label>Name</label> */}
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`address[${index}].name`}
                                                value={
                                                  formik.values.address[index]
                                                    .name
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              {/* <label>Email</label> */}
                                              <input
                                                type="email"
                                                className="form-input form-control"
                                                name={`address[${index}].email`}
                                                value={
                                                  formik.values.address[index]
                                                    .email
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              {/* <label>Phone</label> */}
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`address[${index}].phone_number`}
                                                value={
                                                  formik.values.address[index]
                                                    .phone_number
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              {/* <label>City</label> */}
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`address[${index}].city`}
                                                value={
                                                  formik.values.address[index]
                                                    .city
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              {/* <label>City</label> */}
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`address[${index}].street`}
                                                value={
                                                  formik.values.address[index]
                                                    .street
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              {/* <label>Zipcode</label> */}
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`address[${index}].zip_code`}
                                                value={
                                                  formik.values.address[index]
                                                    .zip_code
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              {/* <label>Country</label> */}
                                              <Select
                                                name={`address[${index}].country`}
                                                options={countriesList}
                                                value={countriesList.find(option => option.value == formik.values.address[index].country) || null} // Ensure correct format
                                                onChange={(selectedOption) => {
                                                  formik.setFieldValue(`address[${index}].country`, selectedOption.value); // ✅ Store only value in Formik
                                                  customHandleInput({
                                                    target: {
                                                      name: `address[${index}].country`,
                                                      value: selectedOption.value, // ✅ Ensure only value is passed
                                                    },
                                                  });
                                                }}
                                                onBlur={formik.handleBlur}
                                                placeholder="Select" 
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              <button
                                                className="btn btn-danger"
                                                // style={{ marginTop: 30 }}
                                                type="button"
                                                onClick={() =>
                                                  arrayHelpers.remove(index)
                                                }
                                              >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          )}
                        />
                        
                           <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Broker
                              </h4>
                            </div>
                          </div>
                        <FieldArray
                          name="brokers"
                          render={(arrayHelpersContact) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => handleAddRowBroker(arrayHelpersContact)}
                              >
                                +
                              </button>
                              {showTableHeadingsBroker && (
                                <table  className="table mb-0">
                                  <thead>
                                    <tr>
                                      <td>Name</td>
                                      <td>Phone Number</td>
                                      <td>Email</td>
                                      <td>CO Code</td>
                                      <td>Phyto Type</td>
                                      <td>Address</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.brokers.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`brokers[${index}].broker_name`}
                                                value={
                                                  formik.values.brokers[index]
                                                    .broker_name
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`brokers[${index}].broker_phone_number`}
                                                value={
                                                  formik.values.brokers[index]
                                                    .broker_phone_number
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="email"
                                                className="form-input form-control"
                                                name={`brokers[${index}].broker_email`}
                                                value={
                                                  formik.values.brokers[index]
                                                    .broker_email
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`brokers[${index}].broker_co_code`}
                                                value={
                                                  formik.values.brokers[index]
                                                    .broker_co_code
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                               <Select
                                                name={`brokers[${index}].broker_phyto_type`}
                                                options={phytoTypes}
                                                value={phytoTypes.find(option => option.value == formik.values.brokers[index].broker_phyto_type) || null} // Ensure correct format
                                                onChange={(selectedOption) => {
                                                  formik.setFieldValue(`brokers[${index}].broker_phyto_type`, selectedOption.value); // ✅ Store only value in Formik
                                                  customHandleInput({
                                                    target: {
                                                      name: `brokers[${index}].broker_phyto_type`,
                                                      value: selectedOption.value, // ✅ Ensure only value is passed
                                                    },
                                                  });
                                                }}
                                                onBlur={formik.handleBlur}
                                                placeholder="Select" 
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`brokers[${index}].broker_address`}
                                                value={
                                                  formik.values.brokers[index]
                                                    .broker_address
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              <button
                                                  className="btn btn-danger"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelpersContact.remove(index)
                                                  }
                                                >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          )}
                        />
                           
                           <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Contact
                              </h4>
                            </div>
                          </div>
                        <FieldArray
                          name="contacts"
                          render={(arrayHelpersContact) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => handleAddRowContact(arrayHelpersContact)}
                              >
                                +
                              </button>
                              {showTableHeadingsContact && (
                                <table  className="table mb-0">
                                  <thead>
                                    <tr>
                                      <td>First Name</td>
                                      <td>Last Name</td>
                                      <td>Email</td>
                                      <td>Phone Number</td>
                                      <td>Function</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.contacts.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`contacts[${index}].contact_first_name`}
                                                value={
                                                  formik.values.contacts[index]
                                                    .contact_first_name
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`contacts[${index}].contact_last_name`}
                                                value={
                                                  formik.values.contacts[index]
                                                    .contact_last_name
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="email"
                                                className="form-input form-control"
                                                name={`contacts[${index}].contact_email`}
                                                value={
                                                  formik.values.contacts[index]
                                                    .contact_email
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`contacts[${index}].contact_phone_number`}
                                                value={
                                                  formik.values.contacts[index]
                                                    .contact_phone_number
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`contacts[${index}].contact_function`}
                                                value={
                                                  formik.values.contacts[index]
                                                    .contact_function
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              <button
                                                  className="btn btn-danger"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelpersContact.remove(index)
                                                  }
                                                >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          )}
                        />
                     
                     
                     
                     <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add Contract Documents
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="documents"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpers.push({
                                    file_link: "",
                                    file_name: "",
                                    file_type: "",                                 
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.documents.map((friend, index) => (
                                    <tr key={index}>
                                                                            <td>
                                        <div className="form-group status pt-3" >
                                          <label>Upload File</label><br/>
                                          <input
                                          className="form-group"
                                          type="file"
                                          name={`documents[${index}].file_link`}
                                          id={`fileupload-${index}`}

                                          onChange={(event) => {
                                            getFileData(event);

                                            const file_link = event.target.files[0];
                                            //console.log("file:", file_link);
                                            //const fileName = file_link.name;
                                            //const fileName = file_link.name;
                                            const reader = new FileReader();

                                            reader.onloadend = () => {
                                              formik.setFieldValue(
                                                `documents[${index}].file_link`,
                                                reader.result
                                              );
                                            };
          
                                            if (file_link) {
                                              reader.readAsDataURL(file_link);
                                            }
                                          }}
                                        />
                                          </div>
                                      </td>

                                    <td>
                                        <div className="form-group status">
                                          <label>File Name</label>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`documents[${index}].file_name`}
                                            id={`filename-${index}`}

                                            value={
                                              formik.values.documents[index]
                                                .file_name
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                             />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="form-group status">
                                          <label>File Type</label><br/>
                                          <Select
                                           name={`documents[${index}].file_type`}
                                           options={fileTypes}
                                           value={fileTypes.find(option => option.value == formik.values.documents[index].file_type) || null} // Ensure correct format
                                           onChange={(selectedOption) => {
                                             formik.setFieldValue(`documents[${index}].file_type`, selectedOption.value); // ✅ Store only value in Formik
                                             customHandleInput({
                                               target: {
                                                 name: `documents[${index}].file_type`,
                                                 value: selectedOption.value, // ✅ Ensure only value is passed
                                               },
                                             });
                                           }}
                                           onBlur={formik.handleBlur}
                                           placeholder="Select" 

                                            // className="w-100"
                                            // name={`documents[${index}].file_type`}
                                            // data={fileTypes}
                                            // value={
                                            //   formik.values.documents[index]
                                            //     .file_type
                                            // }
                                            // onChange={(e) => {
                                            //   formik.handleChange(e);
                                            //   customHandleInput(e);
                                            // }}
                                            //  onBlur={formik.handleBlur}
                                            // options={{
                                            //   placeholder: "Select a File Type",
                                            // }}
                                          />
                                        </div>
                                      </td>
                                 
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />
                        
                        
                     
                        <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add Released Farms
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="customer_farms"
                          render={(arrayHelpersFarm) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpersFarm.push({
                                    farm: "",
                                    ggn_number: "",
                                    farm_size: "",
                                    estimated_crops: "",
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.customer_farms.map((friend, index) => (
                                    <tr key={index}>
                                    
                                      <td>
                                        <div className="form-group status">
                                          <label>Select Farm</label><br/>
                                          <Select
                                           name={`customer_farms[${index}].farm`}
                                           options={farmerLists}
                                           id={`customer_farms-${index}`}
                                           value={farmerLists.find(option => option.value == formik.values.customer_farms[index].farm) || null} // Ensure correct format
                                           onChange={(selectedOption) => {
                                             formik.setFieldValue(`customer_farms[${index}].farm`, selectedOption.value); // ✅ Store only value in Formik
                                             customHandleInput({
                                               target: {
                                                 name: `customer_farms[${index}].farm`,
                                                 value: selectedOption.value, // ✅ Ensure only value is passed
                                               },
                                             });
                                             getFarmData(selectedOption,index);

                                           }}
                                           onBlur={formik.handleBlur}
                                           placeholder="Select" 

                                          />
                                        </div>
                                      </td>
                                      <td>
                                          <div className="form-group ">
                                          <label>GGN Number</label><br/>

                                            <input
                                              type="text"
                                              id={`ggn_number-${index}`}
                                              className="form-input form-control"
                                              name={`customer_farms[${index}].ggn_number`}
                                                value={formik.values.customer_farms[index]?.ggn_number || ''}

                                              // editable={false}
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group ">
                                          <label>Farm Size</label><br/>

                                            <input
                                              type="text"
                                              id={`farm_size-${index}`}
                                              className="form-input form-control"
                                              name={`customer_farms[${index}].farm_size`}
                                                value={formik.values.customer_farms[index]?.farm_size || ''}

                                              // editable={false}
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group ">
                                          <label>Estimated Crops</label><br/>

                                            <input
                                              type="text"
                                              id={`estimated_crops-${index}`}
                                              className="form-input form-control"
                                              name={`customer_farms[${index}].estimated_crops`}
                                                value={formik.values.customer_farms[index]?.estimated_crops || ''}

                                              // editable={false}
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                 
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpersFarm.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />
                       
  
                     
                       <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add Processing Lines
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="customer_processing"
                          render={(arrayHelpersProcessing) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpersProcessing.push({
                                    location: "",
                                    gps_location: "",
                                    description:""
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.customer_processing.map((friend, index) => (
                                    <tr key={index}>
                                    
                                      <td>
                                        <div className="form-group status">
                                          <label>Select Location</label><br/>
                                          <Select
                                            name={`customer_processing[${index}].location`}
                                            options={locationLoading}
                                            value={locationLoading.find(option => option.value == formik.values.customer_processing[index].location) || null} // Ensure correct format
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue(`customer_processing[${index}].location`, selectedOption.value); // ✅ Store only value in Formik
                                              customHandleInput({
                                                target: {
                                                  name: `customer_processing[${index}].location`,
                                                  value: selectedOption.value, // ✅ Ensure only value is passed
                                                },
                                              });
                                              getFarmLocationData(selectedOption, index);
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select"
                                          />
                                        </div>
                                      </td>
                                      <td>
                                          <div className="form-group ">
                                          <label>GPS Location</label><br/>

                                            <input
                                              type="text"
                                              id={`gps_location-${index}`}
                                              className="form-input form-control"
                                              name={`customer_processing[${index}].gps_location`}
                                              // editable={false}
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="form-group ">
                                          <label>Description</label><br/>

                                            <input
                                              type="text"
                                              id={`description-${index}`}
                                              className="form-input form-control"
                                              name={`customer_processing[${index}].description`}
                                              // editable={false}
                                              onChange={formik.handleChange}
                                            />
                                          </div>
                                        </td>
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpersProcessing.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />
                       
                       <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Users
                              </h4>
                            </div>
                          </div>
                        <FieldArray
                          name="users"
                          render={(arrayHelpersUser) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => handleAddRowuser(arrayHelpersUser)}
                              >
                                +
                              </button>
                              {showTableHeadingsUser && (
                                <table  className="table mb-0">
                                  <thead>
                                    <tr>
                                      <td>First Name</td>
                                      <td>Last Name</td>
                                      <td>Email</td>
                                      <td>Password</td>
                                      <td>Function</td>
                                      <td>User Type</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formik.values.users.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`users[${index}].user_first_name`}
                                                value={
                                                  formik.values.users[index]
                                                    .user_first_name
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`users[${index}].user_last_name`}
                                                value={
                                                  formik.values.users[index]
                                                    .user_last_name
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                            <input
                                                  type="email"
                                                  className="form-input form-control"
                                                  name={`users[${index}].user_email`}
                                                  value={formik.values.users[index].user_email}
                                                  onChange={formik.handleChange}
                                                  onBlur={async (e) => {
                                                    const email = e.target.value;

                                                    // Let Formik know the field has been touched
                                                    formik.setFieldTouched(`users[${index}].user_email`, true);

                                                    // Skip empty or invalid emails
                                                    if (!email || !/\S+@\S+\.\S+/.test(email)) return;

                                                    try {
                                                       axios.get(`/customerportal/check-email-exists/${encodeURIComponent(email)}`, {
                                                              headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
                                                            })
                                                            .then((response) => {
                                                              console.log(response);
                                                           
                                                              if (response.data.exists) {
                                                                formik.setFieldError(
                                                                  `users[${index}].user_email`,
                                                                  'This email already exists'
                                                                );
                                                              }
                                                            })
                                                     
                                                     
                                                    } catch (error) {
                                                      console.error('Email validation error:', error);
                                                    }
                                                  }}
                                                />
                                              {formik.touched.users?.[index]?.user_email &&
                                                  formik.errors.users?.[index]?.user_email && (
                                                    <div className="text-danger">
                                                      {formik.errors.users[index].user_email}
                                                    </div>
                                                  )}
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`users[${index}].user_password`}
                                                value={
                                                  formik.values.users[index]
                                                    .user_password
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`users[${index}].user_function`}
                                                value={
                                                  formik.values.users[index]
                                                    .user_function
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className=" status">
                                               <Select
                                                name={`users[${index}].user_type`}
                                                options={usertypes}
                                                value={usertypes.find(option => option.value == formik.values.users[index].user_type) || null} // Ensure correct format
                                                onChange={(selectedOption) => {
                                                  formik.setFieldValue(`users[${index}].user_type`, selectedOption.value); // ✅ Store only value in Formik
                                                  customHandleInput({
                                                    target: {
                                                      name: `users[${index}].user_type`,
                                                      value: selectedOption.value, // ✅ Ensure only value is passed
                                                    },
                                                  });
                                                }}
                                                onBlur={formik.handleBlur}
                                                placeholder="Select" 
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="">
                                              <button
                                                  className="btn btn-danger"
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelpersUser.remove(index)
                                                  }
                                                >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          )}
                        />
                     
                        <small>
                          {backendErrors.status  && (
                            <span className="form-error mt-1">
                              {backendErrors.status}
                            </span>
                          )}
                          <div>
                           
                        </div>
                        </small>
                        <div className="text-end mt-4">
                          <button type="submit"  id="form-submit" className="btn btn-primary" disabled={formik.isSubmitting}> 
                            Add Customer
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddCustomer;
